import { usePunditUserContext } from "@circle-react/contexts/punditUserContext";
import { useBackendProps } from "@circle-react/providers/AppContext";

import {
  LOGGED_IN,
  LOGGED_OUT,
} from "@/react/components/SettingsApp/Navigation/AddLink/constants";
import type { HeaderNavAudienceApiParam } from "@/react/components/SettingsApp/Navigation/hooks/useFetchHeaderNavItems";

import { CommunityDropdown } from "./CommunityDropdown";
import { HeaderV4SideEffects } from "./HeaderV4SideEffects";
import { HeaderWrapper } from "./HeaderWrapper";
import { NavigationBar } from "./NavigationBar";
import { RightActionBlock } from "./RightActionBlock";
import { useHeaderV4Visibility } from "./useHeaderV4Visibility";

export interface HeaderV4Props {
  isPreviewMode?: boolean;
  previewAudience?: HeaderNavAudienceApiParam;
  previewCommunityName?: string;
  previewLogoType?: "logo" | "icon";
  previewLogoUrl?: string | null;
}

export const HeaderV4 = ({
  isPreviewMode = false,
  previewAudience,
  previewCommunityName,
  previewLogoType,
  previewLogoUrl,
}: HeaderV4Props = {}) => {
  const { currentCommunityMember } = usePunditUserContext();
  const { minimal_layout: isMinimalLayout } = useBackendProps();
  const { isHidden } = useHeaderV4Visibility();
  let audience: HeaderNavAudienceApiParam = LOGGED_OUT;
  if (isPreviewMode && previewAudience) {
    audience = previewAudience;
  } else if (currentCommunityMember) {
    audience = LOGGED_IN;
  }

  if (!isPreviewMode && isHidden) {
    return null;
  }

  if (!isPreviewMode && isMinimalLayout) {
    return (
      <>
        <HeaderV4SideEffects />
        <HeaderWrapper>
          <HeaderWrapper.LeftSlot>
            <CommunityDropdown />
          </HeaderWrapper.LeftSlot>
          <HeaderWrapper.RightSlot>
            <RightActionBlock />
          </HeaderWrapper.RightSlot>
        </HeaderWrapper>
      </>
    );
  }

  return (
    <>
      {!isPreviewMode && <HeaderV4SideEffects />}
      <HeaderWrapper>
        <HeaderWrapper.LeftSlot>
          <CommunityDropdown
            isPreviewMode={isPreviewMode}
            previewCommunityName={previewCommunityName}
            previewLogoType={previewLogoType}
            previewLogoUrl={previewLogoUrl}
          />
        </HeaderWrapper.LeftSlot>
        <HeaderWrapper.CenterSlot>
          <NavigationBar isPreviewMode={isPreviewMode} audience={audience} />
        </HeaderWrapper.CenterSlot>
        <HeaderWrapper.RightSlot>
          <RightActionBlock
            isPreviewMode={isPreviewMode}
            previewAudience={previewAudience}
          />
        </HeaderWrapper.RightSlot>
      </HeaderWrapper>
    </>
  );
};
